export default {
    "yes": "Yes",
    "no": "No",
    "0": {
        "question": "Before the meal, my hunger level was:",
        "option": {
            "0": "Not at all hungry",
            "1": "Slightly hungry",
            "2": "Moderately hungry",
            "3": "Very hungry",
            "4": "Extremely hungry"
        }
    },
    "1": {
        "question": "How long has it been since my last meal?",
        "option": {
            "0" : "Less than 1 hour",
            "1": "1–2 hours",
            "2": "3–4 hours",
            "3": "More than 4 hours"
        }
    },
    "2": {
        "question": "Is my body showing signs of hunger?",
        "desc": "(e.g. stomach growling, light dizziness, lack of energy, weakness, fatigue, lack of concentration)"
    },
    "3": {
        "question": "How did I feel before eating?",
        "desc": "(pick the emotions that apply to you)",
        "option": {
            "0": "\uD83D\uDE30 Stress / Pressure",
            "1": "\uD83D\uDE14 Sadness / Grief",
            "2": "\uD83D\uDE12 Boredom",
            "3": "\uD83D\uDE20 Anger / Tension",
            "4": "\uD83D\uDE29 Frustration / Disappointment",
            "5": "\uD83D\uDE22 Loneliness",
            "6": "\uD83D\uDE24 Irritation",
            "7": "\uD83D\uDE2C Guilt",
            "8": "\uD83E\uDEE3 Shame / Self-criticism",
            "9": "\uD83D\uDE35 Confusion / Overload",
            "10": "\uD83E\uDD2F Need for control",
            "11": "\uD83E\uDEE5 Loss of control",
            "12": "\uD83D\uDC94 Concern for someone else",
            "13": "\uD83E\uDD17 Need for a hug / tenderness",
            "14": "\uD83E\uDEE4 Feeling of emptiness or “I don’t know what’s wrong”",
            "15": "\uD83D\uDE0D Excitement / Euphoria (e.g. “I want to celebrate this”)",
            "16": "\uD83E\uDDE0 Nostalgia / Connection with memories"
        }
    },
    "4" : {
        "separator": "Following the meal, I felt",
        "question": "✅ Positive emotions / states:",
        "option": {
            "0": "\uD83D\uDE0A Satisfaction",
            "1": "\uD83D\uDE0C Relief",
            "2": "\uD83C\uDF3F Calmness",
            "3": "\uD83D\uDCAA Energy",
            "4": "\uD83E\uDDE0 Clear thinking",
            "5": "❤\uFE0F Self-care / Respect",
            "6": "\uD83D\uDE42 I feel full enough",
            "7": "\uD83D\uDC9A I feel good about my choice"
        }
    },
    "5": {
        "question": "❗️ Negative emotions / states:",
        "option": {
            "0": "\uD83D\uDE1C Blοated",
            "1": "\uD83D\uDE1E Guilt / Remorse",
            "2": "\uD83E\uDD74 I ate way too much",
            "3": "\uD83D\uDE24 Disappointment",
            "4": "\uD83E\uDEE3 Lack of control",
            "5": "\uD83E\uDD2F It didn’t “fill me up”",
            "6": "\uD83D\uDE36 Absence of emotion – I did it mechanically",
            "7": "\uD83E\uDDE9 I was looking for something else but didn’t find it"
        }
    },
    "6": {
        "question": "\uD83D\uDCCC Extra (for journaling):",
        "placeholder": "✍\uFE0F Do you want to describe it in your own words?"
    },
    "7": {
        "question": "Meal duration",
        "placeholder": "⏱️ How long did your meal last?"
    },

    tooltip: 'Show feelings',
    keepOpen: 'Enable automatic feelings view',
}